import Viewport      from "./Viewport"
import MessagePopup  from "./MessagePopup"
import Sidebar       from "./Sidebar"
import ErrorView     from "./ErrorView"
import LoadingView   from "./LoadingView"
import StartedChange from "./changes/StartedChange"

const MAX_WIDTH  = 25
const MAX_HEIGHT = 15

class ScreenState {
  constructor(name) {
    this.name    = name
  }

  notStarted() { return this.name === "notStarted" }
  running()    { return this.name === "running" }
  error()      { return this.name === "error" }

  static notStarted() { return new ScreenState("notStarted") }
  static running()    { return new ScreenState("running") }
  static error()      { return new ScreenState("error") }

}
class Screen {
  constructor({ window, log }) {

    if (!window) {
      throw new Error("Window is required")
    }

    this.state = ScreenState.notStarted()

    this.window = window
    this.log    = log.forClass("Screen")

  }

  tileSize()     { return 64 }

  _setupElementsIfNeeded(game) {
    if (!this.viewport) {
      const $viewport = this.window.document.querySelector("[data-viewport]")
      const borderWidth = parseInt(this.window.getComputedStyle($viewport)["border-width"].replace("px", ""))
      this.viewport = new Viewport({
        element: $viewport,
        log: this.log,
        width:  Math.floor( ( this.window.innerWidth  - (borderWidth * 2) ) / this.tileSize() ),
        height: Math.floor( ( this.window.innerHeight - (borderWidth * 2) ) / this.tileSize() ),
      })

      this.messagePopup = new MessagePopup({
        element: this.window.document.querySelector("[data-message]"),
        log: this.log,
      })

      this.sidebar = new Sidebar({
        element: this.window.document.querySelector("[data-sidebar]"),
        log: this.log,
      })

      this.errorView = new ErrorView({
        element: this.window.document.querySelector("[data-error-view]"),
        log: this.log,
      })

      this.loadingView = new LoadingView({
        element: this.window.document.querySelector("[data-loading-view]"),
        log: this.log,
      })
      game.inputHandler.onAny = this.messagePopup.hide.bind(this.messagePopup)
    }
  }

  /* Renders the current state of the game */
  render(game, change) {
    const logger = this.log.measurePerformance("render", { state: this.state.name, change: change })
    this._setupElementsIfNeeded(game)

    if (this.state.notStarted()) {
      logger.addDetails({
        idealSize: [ this.viewport.width, this.viewport.height ],
        mapSize: [ game.gameMap.mapWidth, game.gameMap.mapHeight ]
      })

      this._adjustViewPortAndShow({
        width: this.viewport.width,
        height: this.viewport.height,
        mapWidth: game.gameMap.mapWidth,
        mapHeight: game.gameMap.mapHeight,
        logger: logger,
      })

      this.errorView.hide()

      const borderWidth = parseInt(this.window.getComputedStyle(this.viewport.element)["border-width"].replace("px", ""))

      this.messagePopup.place({
        viewportCenterX: this.viewport.element.offsetLeft + this.viewport.element.offsetWidth / 2,
        viewportCenterY: this.viewport.element.offsetTop + this.viewport.element.offsetHeight / 2,
      })
      this.messagePopup.hide()
      //this.loadingView.hide()
      this.state = ScreenState.running()
      game.fireStateChange(new StartedChange(change.message))
    }
    else if (this.state.running()) {
      if (change.isLoadUrl()) {
        this.loadingView.show()
        this.errorView.hide()
        this.messagePopup.hide()
        this.sidebar.render(game, change)
        setTimeout( () => { this.window.location = change.url }, 1000)
      }
      else if (change.type === "errorOccured") {
        let errorMessage = "A unknown error occured"
        if (change.error && change.error.message) {
          errorMessage = change.error.message
        }

        if (change.error && change.error.isTransient && change.error.isTransient()) {
          errorMessage = `${errorMessage}. Will retry in one second to see if that resolves it`
          setTimeout( () => { this.window.location.reload() }, 1000)
        }
        this.state = ScreenState.error()
        this.viewport.hide()
        this.sidebar.hide()
        this.loadingView.hide()
        this.errorView.show({ message: errorMessage })
        this.messagePopup.hide()
        logger.addDetails({ errorOccured: true })
      }
      else if (change.type === "loadingMap") {
        this.loadingView.show()
        this.errorView.hide()
        this.messagePopup.hide()
        this.sidebar.render(game, change)
      }
      else {
        this.loadingView.hide()
        this.errorView.hide()
        this.viewport.render(game, change)
        this.sidebar.render(game, change)
        this.messagePopup.render(game, change)
      }
    }

    logger.end()
  }

  _adjustViewPortAndShow({ width, height, mapWidth, mapHeight, logger }) {

    if (width > mapWidth) {
      logger.addDetails({ shrinkToGameWidth: true })
      width = mapWidth
    }
    if (height > mapHeight) {
      logger.addDetails({ shrinkToGameHeight: true })
      height = mapHeight
    }
    if (width > MAX_WIDTH) {
      logger.addDetails({ shrinkToMaxWidth: true })
      width = MAX_WIDTH
    }
    if (height > MAX_HEIGHT) {
      logger.addDetails({ shrinkToMaxHeight: true })
      height = MAX_HEIGHT
    }

    const tileWidthOfSidebar = Math.floor(this.sidebar.width() / this.tileSize())
    width = width - tileWidthOfSidebar
    this.viewport.show({ 
      width: width,
      height: height,
      tileWidth: this.tileSize(),
      tileHeight: this.tileSize(),
    })
    this.viewport.clear()

    let row = 0
    while (row < height) {
      const gameMapRow = this.window.document.createElement("div")

      gameMapRow.classList.add("row")

      let col = 0

      while (col < width) {
        const tile = this.window.document.createElement("div")
        tile.classList.add("tile")
        gameMapRow.appendChild(tile)
        col = col + 1
      }
      this.viewport.addRow(gameMapRow)
      row = row + 1
    }
    return [ width, height ]
  }
}

export default Screen
